export enum PriceIncreaseTypeEnum {
  PERCENTAGE = "PERCENTAGE",
  FIXED = "FIXED",
}
